import React from "react";
import {useSelector} from "react-redux";
import {Container} from "reactstrap";
import RecentlyAddedResources from "components/RecentlyAddedResources/RecentlyAddedResources";
import {getMonitoringSystems} from "store/actions";
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import Card from "components/PurpleTheme/Card";

const AllRecentResources = () => {
  const dispatch = useDispatch();
  const {monitoring_systems} = useSelector(state => ({
    monitoring_systems: state.Dashboard.monitoring_systems,
  }));

  useEffect(() => {
    dispatch(getMonitoringSystems());
  }, [getMonitoringSystems]);

  return (
    <React.Fragment>
      <Container fluid className="mt-5">
        <Card className="p-4">
          <RecentlyAddedResources itemsPerPage={100} height="100%" maxHeight="100%" monitoringSystems={monitoring_systems}/>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default AllRecentResources;